import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'muni-gameday-account-cell',
  template: `
    <muni-gameday-profile-overview-open-link
      [text]="order?.name || order?.account"
      [linkType]="order?.linkType"
    >
    </muni-gameday-profile-overview-open-link>
  `
})
export class AccountCellRendererComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public order;

  public agInit(params: ICellRendererParams) {
    this.params = params;
    this.order = this.params.data || {};
  }

  public refresh(): boolean {
    return false;
  }
}
